import magic from "../magic";
import { HEATER_NODE_ID } from "../constants";

// No automatic legacy retry: a timed-out write may already have taken effect.
const parameters = {
    timer: [0x2000, 4, 0, 0xffffffff],
    power: [0x2001, 1, 8, 35],
    idealTemperature: [0x2002, 2, 0, 3000],
    turnoffTemperature: [0x2003, 2, 1000, 3500],
    climate: [0x2004, 1, 0, 1],
    pumpCounter: [0x2005, 4, 0, 0xffffffff],
};
const fields = {
    timer: ["heater_timer", value => value],
    power: ["target_power", value => value],
    idealTemperature: ["ideal_temp", value => value / 100],
    turnoffTemperature: ["turnoff_temp", value => value / 100],
    climate: ["climate_control_enabled", value => value],
    pumpCounter: ["pump_counter", value => value],
};

export async function writeHeaterParameter(name, value) {
    const spec = parameters[name];
    if (!spec || !Number.isInteger(value) || value < spec[2] || value > spec[3]) {
        throw new Error(`Invalid heater ${name} value`);
    }
    const [index, size] = spec;
    const bytes = Uint8Array.from({ length: size }, (_, i) => (value >>> (8 * i)) & 0xff);
    await magic.writeSDO(HEATER_NODE_ID, index, 0, bytes);
    const [field, convert] = fields[name];
    magic.heater[field] = convert(value);
    magic.bleEventDispatcher.emit("heater", magic.heater);
}
